import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        width: '100%',
        height: '100%',
        padding: '16px 0px 16px 16px',
        overflow: 'hidden',
        borderRight: `1px solid #CDD3CD`,
      },
      header: {
        width: '100%',
        backgroundColor: '#ffffff',
        borderTop: `1px solid #CDD3CD`,
        borderBottom: `1px solid #CDD3CD`,
        position: 'absolute',
        left: 0,
        top: 0,
        padding: '1rem',
        zIndex: 1,
      },
      noChat: {
        display: 'flex',
        width: '100%',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: sicrediStyle.secondarySicrediLight,
        '& svg': {
          fontSize: 64,
          marginBottom: 16,
        },
      },
      conversa: {
        flex: 1,
        maxHeight: '100%',
        overflowX: 'hidden',
        overflowY: 'auto',
        boxSizing: 'border-box',
        paddingRight: theme.spacing(1),
        marginTop: '35px',
        scrollbarColor: `${sicrediStyle.primarySicredi} ${sicrediStyle.secondarySicrediLight}`,
        scrollbarWidth: 'thin',
        '&::-webkit-scrollbar-track': {
          backgroundColor: sicrediStyle.sicrediLightest,
        },

        '&::-webkit-scrollbar': {
          width: '12px',
          height: '12px',
        },

        '&::-webkit-scrollbar-thumb': {
          transition: 'all 0.3s ease',
          borderRadius: '10px',
          backgroundColor: sicrediStyle.sicrediLight,
          borderWidth: '3px',
          borderStyle: 'solid',
          borderColor: sicrediStyle.sicrediLightest,

          '&:hover': {
            transition: 'all 0.3s ease',
            borderWidth: '2px',
            backgroundColor: `darken(${sicrediStyle.sicrediLight}, 5%)`,
          },
        },

        '&::-webkit-scrollbar-button': {
          display: 'none',
        },
      },
      duvida: {
        display: 'grid',
        gridTemplateColumns: 'repeat(6, 1fr)',
        rowGap: '8px',
        columnGap: '16px',
        alignItems: 'center',
        width: '100%',
        padding: `16px 0`,
        boxSizing: 'border-box',
      },
      duvidaData: {
        gridColumn: '1 / span 6',
        fontSize: 12,
        fontWeight: 700,
        textAlign: 'left',
        color: sicrediStyle.secondarySicrediDark,
      },
      pergunta: {
        gridColumn: '1 / span 5',
        display: 'flex',
        padding: theme.spacing(1, 2),
        boxSizing: 'border-box',
        backgroundColor: sicrediStyle.primarySicredi,
        borderRadius: '8px 8px 8px 0px',
      },
      perguntaText: {
        flex: 'auto',
        color: 'white',
        fontSize: 16,
        fontWeight: 300,
        boxSizing: 'border-box',
      },
      responderButton: {
        gridColumn: '6 / 7',
        flexShrink: 0,
        color: sicrediStyle.primarySicrediDark,
        backgroundColor: sicrediStyle.primarySicrediLight,
        fontSize: 11,
        borderRadius: 8,
        padding: theme.spacing(1, 2),
        '&:hover': {
          backgroundColor: sicrediStyle.secondarySicredi,
          color: 'white',
        },
      },
      toggling: {
        boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25) !important',
      },
      visibilidade: {
        gridColumn: '3 / 6',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& button': {
          width: '50%',
          '&.Mui-disabled:not($toggling)': {
            backgroundColor: sicrediStyle.primarySicrediDark,
            color: 'white',
            boxShadow: 'inset 0px 4px 4px rgba(0, 0, 0, 0.25) !important',
          },
        },
      },
      perguntaPrivate: {
        borderRadius: '8px 0 0 8px !important',
      },
      perguntaPublic: {
        borderRadius: '0 8px 8px 0 !important',
      },
      respostaData: {
        gridColumn: '1 / span 5',
        fontSize: 12,
        fontWeight: 700,
        textAlign: 'right',
        color: sicrediStyle.secondarySicrediDark,
        paddingTop: theme.spacing(1),
      },
      resposta: {
        gridColumn: '1 / span 5',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        boxSizing: 'border-box',
        backgroundColor: '#FFF',
        borderRadius: '8px 8px 0 8px',
        borderColor: sicrediStyle.primarySicredi,
        borderWidth: 1,
        borderStyle: 'solid',
        padding: theme.spacing(1, 2),
      },
      respostaText: {
        flex: 'auto',
        textAlign: 'left',
        fontSize: 16,
        fontWeight: 300,
        color: sicrediStyle.secondarySicrediDarker,
        boxSizing: 'border-box',
      },
      editarResposta: {
        gridColumn: '6 / 7',
        flexShrink: 0,
        backgroundColor: sicrediStyle.secondarySicrediDark,
        textTransform: 'none',
        color: 'white',
        fontSize: 11,
        borderRadius: 8,
        padding: theme.spacing(1, 2),
        '&:hover': {
          backgroundColor: sicrediStyle.secondarySicrediDarker,
        },
      },
      buttonIcon: {
        width: 16,
        height: 16,
      },
      input: {
        flexShrink: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        minHeight: 100,
        // borderTop: `1px solid ${sicrediStyle.secondarySicrediLight}`,
        boxSizing: 'border-box',
        transformOrigin: 'center bootom',
        transform: 'scaleY(0)',
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
      },
      inputDuvida: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        flexShrink: 0,
        borderRadius: '8px',
        border: `1px solid ${sicrediStyle.secondarySicrediLight}`,
        boxSizing: 'border-box',
        overflow: 'hidden',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
        // padding: `0 16px`,
      },
      inputDuvidaVoid: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
        width: '100%',
        flexShrink: 0,

        '& > button': {
          borderRadius: '8px',
          border: `1px solid ${sicrediStyle.secondarySicrediLight}`,
        },
      },
      inputDuvidaText: {
        flex: 'auto',
        lineHeight: '38px',
        overflow: 'hidden',
        fontSize: 16,
        fontWeight: 300,
        color: sicrediStyle.secondarySicrediDarker,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
      cancelarResposta: {
        flexShrink: 0,
        fontSize: 12,
      },
      textField: {
        marginTop: theme.spacing(1),
        boxSizing: 'border-box',
        borderRadius: '8px',
        border: `1px solid ${sicrediStyle.primarySicredi}`,
        height: '100%',
        '& .MuiInputBase-root': {
          padding: '8px 16px',
          boxSizing: 'border-box',
        },
      },
      endAdornment: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
      counter: {
        fontSize: 12,
        color: sicrediStyle.secondarySicredi,
        '& > span': {
          transition: 'color 0.3s ease',
          '&.error': {
            color: sicrediStyle.dangerSicredi,
          },
        },
      },
      submitIcon: {
        padding: '6px',
        marginLeft: '6px',
        fontSize: 16,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      backdrop: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        pointerEvents: 'none',
        zIndex: 24,
      },
      backdropOpen: {
        pointerEvents: 'all',
      },
      paper: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        transitionProperty: 'transform, opacity',
        transitionDuration: '200ms, 150ms',
        transitionTimingFunction: 'cubic-bezier(0.4, 0.0, 1, 1)',
        transformOrigin: 'top right',
        transform: 'scale(0)',
        maxWidth: 280,
        opacity: 0,
      },
      paperOpen: {
        transitionTimingFunction: 'cubic-bezier(0.0, 0.0, 0.2, 1)',
        transform: 'scale(1)',
        opacity: 1,
      },
    }),
  { name: 'ChatAssessor' }
);
